import Headroom from 'headroom.js';
import { headerHeight } from '../helpers';

if (!window.pingInit) window.pingInit = {};

$(function () {
  const $siteHeader = $(".site-header");
  const $header = $siteHeader.find(".header__container");
  if ($siteHeader <= 0 || $header.length <= 0) return false;
  const mobileMenu = document.querySelector(
    ".header__mobile-menu.header__mobile-menu--dropdown"
  );
  const $deskSearchBar = $(".header__search-popup");
  const deskSearchClose = document.querySelector(".header__search-popup__close");

  $("html").css("scroll-padding-top", headerHeight() + "px");
  $("#CartPopup").css("top", headerHeight() + "px");

  $(window).on("resize", function () {
    $("html").css("scroll-padding-top", headerHeight() + "px");
    $("#CartPopup").css("top", headerHeight() + "px");
  });

  const syncFloatingElements = (searchTop) => {
    if ($deskSearchBar.length > 0) {
      $deskSearchBar.css("top", searchTop);
    }

    if (mobileMenu != null) {
      $(mobileMenu).css("top", headerHeight() + "px");
      $(mobileMenu).css("height", "calc(100vh - " + headerHeight() + "px)");
    }
  };

  const closeDeskSearch = () => {
    if ($deskSearchBar.length <= 0) return;

    $deskSearchBar.removeClass("open");
    $header.find(".header__right__element.search").removeClass("open");
  };

  /* ====================== HeadrooomJS ====================== */
  const header = document.querySelector("header.site-header");
  if (header) {
    const getScrollTop = () => {
      return window.pageYOffset
        || window.scrollY
        || document.documentElement.scrollTop
        || document.body.scrollTop
        || 0;
    };

    const syncHeaderScrollState = () => {
      const isAtTop = getScrollTop() <= 1;
      header.classList.toggle("headroom--top", isAtTop);
      header.classList.toggle("headroom--not-top", !isAtTop);
      header.classList.toggle("is-top", isAtTop);
      header.classList.toggle("is-sticky", !isAtTop);
      header.setAttribute("data-header-state", isAtTop ? "top" : "sticky");
    };

    const options = {
      offset: 1,
      tolerance: {
        up: 20,
        down: 20,
      },
      onTop: function () {
        syncHeaderScrollState();
      },
      onNotTop: function () {
        syncHeaderScrollState();
      },
      onPin: function () {
        syncHeaderScrollState();
        if (this.elem) {
          const $announcement = $(this.elem).find(
            "#shopify-section-announcement-bar"
          );
          if ($announcement.length > 0) {
            $announcement.slideDown(250);
            syncFloatingElements(headerHeight() + "px");
          }
        }
      },
      onUnpin: function () {
        syncHeaderScrollState();
        if (this.elem) {
          const $announcement = $(this.elem).find(
            "#shopify-section-announcement-bar"
          );
          if ($announcement.length > 0) {
            $announcement.slideUp(250);
            syncFloatingElements("calc(" + headerHeight() + "px - 34px)");
          }
        }
      },
    };

    const headroom = new Headroom(header, options);
    headroom.init();
    syncHeaderScrollState();
    window.addEventListener("scroll", syncHeaderScrollState, { passive: true });
    window.addEventListener("resize", syncHeaderScrollState);
  }

  /* ======================== Mobile Menu ======================== */
  if (mobileMenu != null) {
    mobileMenu
      .querySelectorAll(
        ".header__mobile-menu--dropdown__navigation__first-level__title[data-link-opener]"
      )
      .forEach((firstLevelItem) => {
        firstLevelItem.addEventListener("click", (e) => {
          e.preventDefault();

          if (firstLevelItem.querySelector("a.active") != null) {
            return;
          }
          mobileMenu
            .querySelector(
              ".header__mobile-menu--dropdown__navigation__first-level__title a.active"
            )
            ?.classList.remove("active");
          mobileMenu
            .querySelector(
              ".header__mobile-menu--dropdown__navigation__second-level.open"
            )
            ?.classList.remove("open");

          const drawerAttribute = firstLevelItem.dataset.linkOpener;
          const secondLevelItem = mobileMenu.querySelector(
            '.header__mobile-menu--dropdown__navigation__second-level[data-level="' +
              drawerAttribute +
              '"]'
          );
          if (secondLevelItem == null) {
            return;
          }

          secondLevelItem.classList.add("open");
          firstLevelItem.querySelector("a").classList.add("active");
        });
      });

    mobileMenu
      .querySelectorAll(
        ".header__mobile-menu--dropdown__navigation__second-level"
      )
      .forEach((secondLevelItem) => {
        secondLevelItem
          .querySelectorAll(
            ".header__mobile-menu--dropdown__navigation__second-level__title"
          )
          .forEach((secondLevelItemTitle) => {
            secondLevelItemTitle.addEventListener("click", (e) => {
              e.preventDefault();

              if(secondLevelItemTitle.hasAttribute('data-link')){
                  let link = secondLevelItemTitle.getAttribute('data-link');
                  document.location.href = link;
              }

              const drawerAttribute = secondLevelItemTitle.dataset.linkOpener;
              const thirdLevelItem = secondLevelItem.querySelector(
                '.header__mobile-menu--dropdown__navigation__third-level[data-level="' +
                  drawerAttribute +
                  '"]'
              );
              if (thirdLevelItem == null) {
                return;
              }

              thirdLevelItem.classList.add("open");
              mobileMenu
                .querySelectorAll(
                  ".header__mobile-menu--dropdown__navigation__second-level__title"
                )
                .forEach(
                  (secondLevelItemTitle) =>
                    (secondLevelItemTitle.style.opacity = 0)
                );
              mobileMenu
                .querySelectorAll(
                  ".header__mobile-menu--dropdown__navigation__first-level__title"
                )
                .forEach(
                  (firstLevelItemTitle) =>
                    (firstLevelItemTitle.style.opacity = 0)
                );
              mobileMenu.querySelector(
                ".header__mobile-menu--dropdown__footer"
              ).style.display = "none";
            });
          });
      });

    mobileMenu
      .querySelectorAll(
        ".header__mobile-menu--dropdown__navigation__third-level"
      )
      .forEach((thirdLevelItem) => {
        thirdLevelItem
          .querySelector(
            ".header__mobile-menu--dropdown__navigation__third-level__go-back"
          )
          .addEventListener("click", () => {
            thirdLevelItem.classList.remove("open");

            mobileMenu
              .querySelectorAll(
                ".header__mobile-menu--dropdown__navigation__second-level__title"
              )
              .forEach(
                (secondLevelItemTitle) =>
                  (secondLevelItemTitle.style.opacity = 1)
              );
            mobileMenu
              .querySelectorAll(
                ".header__mobile-menu--dropdown__navigation__first-level__title"
              )
              .forEach(
                (firstLevelItemTitle) => (firstLevelItemTitle.style.opacity = 1)
              );
            mobileMenu.querySelector(
              ".header__mobile-menu--dropdown__footer"
            ).style.display = "block";
          });
      });

    mobileMenu
      .querySelectorAll(".header__mobile-menu--dropdown-navigation__close")
      .forEach((iconClose) => {
        iconClose.addEventListener("click", () => {
          document
            .querySelector(".backdrop-filter.backdrop-filter--mobile")
            .classList.remove("open");
          document.querySelector("html").style.overflowY = "";
          mobileMenu.classList.remove("open");
          $header[0].style.opacity = 1;
        });
      });

    $header[0]
      .querySelector(".header__burger-icon")
      .addEventListener("click", (e) => {
        mobileMenu.classList.add("open");
        document
          .querySelector(".backdrop-filter.backdrop-filter--mobile")
          .classList.add("open");
        document.querySelector("html").style.overflowY = "hidden";
        $header[0].style.opacity = 0;
      });
  }

  /* ======================== Desktop Menu ======================== */
  const desktopMenu = $header[0].querySelector(".header__desktop-menu");
  if (desktopMenu != null) {
    if (desktopMenu.classList.contains("header__desktop-menu--dropdown")) {
      let activeDesktopDropdown = null;

      const setDesktopMenuState = (isOpen) => {
        $siteHeader.toggleClass("is-menu-open", isOpen);
      };

      const openDesktopDropdown = (dropdownInlineElement) => {
        if (activeDesktopDropdown === dropdownInlineElement) {
          setDesktopMenuState(true);
          return;
        }

        const dropdownInlineElementWrapper =
          dropdownInlineElement.querySelector(
            ".header__desktop-menu--dropdown__dropdown-wrapper"
          );
        if (dropdownInlineElementWrapper == null) {
          return;
        }

        if (activeDesktopDropdown != null) {
          closeDesktopDropdown(activeDesktopDropdown);
        }

        const searchController = document.querySelector(".header-component__element.search");
        if (searchController != null && searchController.classList.contains("open")) {
          searchController.click();
        }

        const backdropFilter = document.querySelector(
          `.backdrop-filter[data-backdrop-filter="${dropdownInlineElementWrapper.dataset.backdropFilter}"]`
        );
        if (backdropFilter != null) {
          backdropFilter.style.height = `${dropdownInlineElementWrapper.clientHeight}px`;
          backdropFilter.style.top = `${headerHeight()}px`;
          backdropFilter.classList.add("open");
        }

        dropdownInlineElementWrapper.classList.add("open");
        activeDesktopDropdown = dropdownInlineElement;
        setDesktopMenuState(true);
      };

      const closeDesktopDropdown = (dropdownInlineElement) => {
        if (dropdownInlineElement == null) {
          return;
        }

        const dropdownInlineElementWrapper =
          dropdownInlineElement.querySelector(
            ".header__desktop-menu--dropdown__dropdown-wrapper"
          );
        if (dropdownInlineElementWrapper == null) {
          return;
        }

        const backdropFilter = document.querySelector(
          `.backdrop-filter[data-backdrop-filter="${dropdownInlineElementWrapper.dataset.backdropFilter}"]`
        );
        if (backdropFilter != null) {
          backdropFilter.classList.remove("open");
        }

        dropdownInlineElementWrapper.classList.remove("open");

        if (activeDesktopDropdown === dropdownInlineElement) {
          activeDesktopDropdown = null;
        }
      };

      const closeAllDesktopDropdowns = () => {
        dropdownInlineElements.forEach((dropdownInlineElement) => {
          closeDesktopDropdown(dropdownInlineElement);
        });
        setDesktopMenuState(false);
      };

      const dropdownInlineElements = desktopMenu.querySelectorAll(
        ".header__desktop-menu--dropdown__inline-elements__link"
      );
      dropdownInlineElements.forEach((dropdownInlineElement) => {
        const dropdownInlineElementWrapper = dropdownInlineElement.querySelector(
          ".header__desktop-menu--dropdown__dropdown-wrapper"
        );

        dropdownInlineElement.addEventListener("mouseenter", () => {
          openDesktopDropdown(dropdownInlineElement);
        });

        dropdownInlineElement.addEventListener("mouseleave", (event) => {
          if (
            dropdownInlineElementWrapper != null
            && dropdownInlineElementWrapper.contains(event.relatedTarget)
          ) {
            return;
          }

          closeDesktopDropdown(dropdownInlineElement);
          setDesktopMenuState(
            desktopMenu.querySelector(".header__desktop-menu--dropdown__dropdown-wrapper.open") != null
          );
        });

        if (dropdownInlineElementWrapper == null) return;

        dropdownInlineElementWrapper.addEventListener("mouseenter", () => {
          openDesktopDropdown(dropdownInlineElement);
        });

        dropdownInlineElementWrapper.addEventListener("mouseleave", (event) => {
          if (dropdownInlineElement.contains(event.relatedTarget)) {
            return;
          }

          closeDesktopDropdown(dropdownInlineElement);
          setDesktopMenuState(false);
        });
      });

      desktopMenu.addEventListener("mouseleave", () => {
        closeAllDesktopDropdowns();
      });
    }
  }

  /* ==================== Desktop Search PopUp ==================== */
  const $iconSearch = $header.find(".header__right__element.search");
  const $searchInput = $deskSearchBar.find('form input[type="text"]');

  $deskSearchBar.on('transitionend', function(){
    window.requestAnimationFrame(function() {
      const $deskSearchBar = $(".header__search-popup");
      if($deskSearchBar.length && $deskSearchBar.hasClass('open')){
        $searchInput.trigger("focus");
      } else {
        $searchInput.trigger("blur");
      }
    });
  })

  if ($deskSearchBar.length > 0) {
    $deskSearchBar.css("top", headerHeight() + "px");

    if ($iconSearch.length > 0) {
      $iconSearch.on("click", function (e) {
        e.preventDefault();
        $deskSearchBar.toggleClass("open");
        $iconSearch.toggleClass("open");
      });
    }

    if (deskSearchClose) {
      deskSearchClose.addEventListener("click", () => {
        closeDeskSearch();
      });
    }

    $(window).on("resize", function () {
      if ($(window).outerWidth() <= 1024) {
        $deskSearchBar.css("top", headerHeight() + "px");
      }
    });
  }
});
